import { initStarRatingComponent } from "./star_rating_component.js";

/**
 * Initilizes the reviews form.
 */
function initCountryFlagSelector(container: HTMLElement) {
    const imgFlag = container.querySelector('img.flag-preview') as HTMLImageElement;
    if (!imgFlag) {
        console.warn('Flag image not found');
        return;
    }

    const selectElement = container.querySelector('.pc_sp_review_country_select') as HTMLSelectElement;
    if (!selectElement) return; // Ensure selectElement exists

    const updateFlag = function() {
        const selectedValue = selectElement.value as string;
        if (!selectedValue) {
            imgFlag.style.display = 'none';
        } else {
            imgFlag.style.display = 'inline-block';
            const flagUrl = selectElement.getAttribute('data-flag-url');
            if (flagUrl && imgFlag) {
                imgFlag.src = `${flagUrl}${selectedValue.toUpperCase()}.svg`;
                imgFlag.alt = selectedValue; // Set alt text to the country code
            }
        }
    };  

    selectElement.addEventListener('change', (event) => {
        updateFlag();
    });
    updateFlag();
}


function validateForm(form: HTMLFormElement): boolean {
    const ratingInput = form.querySelector('input[name="review_rating"]') as HTMLInputElement;
    const titleInput = form.querySelector('input[name="review_title"]') as HTMLInputElement;
    const errorMessages = form.querySelectorAll('.text_error_message') as NodeListOf<HTMLElement>;

    // Clear previous error messages
    errorMessages.forEach(msg => msg.classList.add('hidden'));

    let isValid = true;

    const ratingValue = parseInt(ratingInput.value) || 0;
    if (!ratingInput.value) {
        const ratingError = form.querySelector('.text_error_message[for="review_rating"]') as HTMLElement;
        if (ratingError) ratingError.classList.remove('hidden');
        isValid = false;
    }

    if (ratingValue < 1 || ratingValue > 5) {
        const ratingError = form.querySelector('.text_error_message[for="review_rating"]') as HTMLElement;
        if (ratingError) ratingError.classList.remove('hidden');
        isValid = false;
    }

    if (!titleInput.value) {
        const titleError = form.querySelector('.text_error_message[for="review_title"]') as HTMLElement;
        if (titleError) titleError.classList.remove('hidden');
        isValid = false;
    }

    return isValid;
}


function ShowReviewSubmissionSuccessMessage(form: HTMLFormElement) {
    const successMessage = form.querySelector('.message_submission_success') as HTMLElement;
    if (successMessage) {
        successMessage.classList.remove('hidden');
        successMessage.classList.remove('opacity-0');
        successMessage.classList.add('flex');
        successMessage.classList.add('opacity-100');

        setTimeout(() => {
            successMessage.classList.add('opacity-0');
            successMessage.classList.add('hidden');
        }, 3000);
    }
}

function ShowReviewSubmissionErrorMessage(form: HTMLFormElement) {
    const errorMessage = form.querySelector('.message_submission_error') as HTMLElement;
    if (errorMessage) {
        errorMessage.classList.remove('hidden');
        errorMessage.classList.remove('opacity-0');
        errorMessage.classList.add('flex');
        errorMessage.classList.add('opacity-100');

        setTimeout(() => {
            errorMessage.classList.add('opacity-0');
            errorMessage.classList.add('hidden');
        }, 3000);
    }
}

export function initReviewsForm(){
    const reviewForm = document.querySelector('.pc_sp_add_review_container') as HTMLFormElement;
    if (!reviewForm) return;

    initCountryFlagSelector(reviewForm);
    initStarRatingComponent(reviewForm);

    let isSubmitting = false;

    reviewForm.addEventListener('submit', (event) => {
        event.preventDefault();
        if (isSubmitting) return;

        isSubmitting = true;

        if (validateForm(reviewForm)) {
            const loader = reviewForm.querySelector('.pc_sp_loader_inline') as HTMLElement;
            loader.style.display = "inline-block";
            // Submit the form or perform the desired action
            const formData = new FormData(reviewForm);
            const ajaxurl = reviewForm.getAttribute('action') || '';
            console.log(ajaxurl);

            fetch(ajaxurl, {
                method: 'POST',
                body: formData,
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    ShowReviewSubmissionSuccessMessage(reviewForm);
                    // reset form fields
                    reviewForm.reset();
                } else {
                    ShowReviewSubmissionErrorMessage(reviewForm);
                }
            })
            .catch(error => {
                console.error('Error:', error);
                ShowReviewSubmissionErrorMessage(reviewForm);
            })
            .finally(() => {
                isSubmitting = false;
                loader.style.display = "none";
            });
        }
    });
}